module.exports = __webpack_public_path__ + "static/img/connect02.c3bd14f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/aircolor/connect02.png
// module id = A+Zr
// module chunks = 1